<template>
    <div id="app" class="u-full-height u-flex">
        <main-navigation v-if="isAuthenticated" id="top" />

        <main class="main u-flex u-flex-col u-full-width" :class="{ 'main--authenticated': isAuthenticated }">
            <head-bar />
            <service-worker-update-banner v-if="updateExists" @submit="refreshApp" />

            <div class="page-background">
                <div class="m-24 pt-56">
                    <router-view/>
                </div>

                <div class="u-text-center pb-24">
                    <circle-button
                        v-if="showTopButton"
                        icon="chevron-up"
                        class="top-button"
                        title="Nach oben"
                        theme="primary"
                        v-scroll-to="'#top'"
                    />
                </div>
            </div>
        </main>
    </div>
</template>


<script>
import serviceWorkerUpdate from '@/mixins/service-worker-update'
import MainNavigation from '@/components/layout/MainNavigation.vue'
import HeadBar from '@/components/layout/HeadBar.vue'
import CircleButton from '@/components/ui/CircleButton.vue'
import ServiceWorkerUpdateBanner from '@/components/ServiceWorkerUpdateBanner.vue'

export default {
    components: { ServiceWorkerUpdateBanner, CircleButton, HeadBar, MainNavigation },

    data: () => ({ showTopButton: false }),

    computed: {
        isAuthenticated () {
            return this.$store.getters.isAuthenticated
        },
    },

    mixins: [serviceWorkerUpdate],

    mounted () {
        window.addEventListener('scroll', this.onScroll)
    },

    destroyed () {
        window.addEventListener('scroll', this.onScroll)
    },

    methods: {
        onScroll () {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

            this.showTopButton = scrollTop > 1000
        },
    },
}
</script>

<style lang="scss">
@import './assets/css/main.scss';

.main {
    padding-bottom: 50px !important;

    &--authenticated {
        padding-left: $main-navigation-width-desktop;

        @include media-breakpoint-down(md) {
            padding-left: $main-navigation-width-mobile;
        }
    }
}

body {
    background-image: url("~@/assets/page-pattern.png");
}

.top-button {
    margin: auto;
}
</style>
